import config from "../app.json";
import AutoComplete from "react-google-autocomplete";
import { Row } from "react-bootstrap";

const GoogleAutoComplete = ({
  address,
  setAddress,
  setCity,
  setState,
  setZipCode,
  setLatitude,
  setLongitude,
  label,
  className,
}) => {
  if (!setAddress) {
    return null;
  }

  const _ = require("lodash");

  const getGoogleInfo = (array, typeName) => {
    return _.find(array, function (element) {
      return element.types[0] === typeName;
    });
  };

  const handleGoogleAddress = (place) => {
    setAddress(place.formatted_address);

    const city = getGoogleInfo(
      place.address_components,
      "administrative_area_level_2"
    );

    if (setCity && city) {
      setCity(city.long_name);
    }

    const state = getGoogleInfo(
      place.address_components,
      "administrative_area_level_1"
    );

    if (setState && state) {
      setState(state.long_name);
    }

    const zipCode = getGoogleInfo(place.address_components, "postal_code");

    if (setZipCode && zipCode) {
      setZipCode(zipCode.long_name);
    }

    if (setLatitude) {
      setLatitude(place.geometry.location.lat());
    }

    if (setLongitude) {
      setLongitude(place.geometry.location.lng());
    }
  };

  return (
    <div className="form-group">
      <Row>
        <label>{label}</label>
      </Row>

      <div className={className}>
        <AutoComplete
          apiKey={config.GOOGLE_API_KEY}
          className="form-control "
          value={address}
          onChange={(x) => setAddress(x.target.value)}
          language={["en"]}
          translate={true}
          placeholder="Address"
          onPlaceSelected={handleGoogleAddress}
          options={{
            types: ["geocode", "establishment"],
          }}
        />
      </div>
    </div>
  );
};
export default GoogleAutoComplete;
